(function () {
  // Keeps the cart disclosure hover tooltip within the viewport.
  // On hover we measure the tooltip and set a `--cart-disclosure-tooltip-shift`
  // custom property that nudges it back into view;
  // the arrow is counter-shifted in CSS so it keeps pointing at the icon.
  const VIEWPORT_MARGIN = 16;

  function positionTooltip(button) {
    const tooltip = button.querySelector('.cart-item__disclosure-tooltip');
    if (!tooltip) return;

    // Reset before measuring so we read the natural, centered position.
    tooltip.style.setProperty('--cart-disclosure-tooltip-shift', '0px');

    const rect = tooltip.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    let shift = 0;

    if (rect.right > viewportWidth - VIEWPORT_MARGIN) {
      shift = viewportWidth - VIEWPORT_MARGIN - rect.right;
    } else if (rect.left < VIEWPORT_MARGIN) {
      shift = VIEWPORT_MARGIN - rect.left;
    }

    tooltip.style.setProperty('--cart-disclosure-tooltip-shift', `${Math.round(shift)}px`);
  }

  function onPointerOver(event) {
    const button = event.target.closest?.('.cart-item__disclosure');
    if (!button || button.dataset.tooltipPositioned === 'true') return;

    button.dataset.tooltipPositioned = 'true';
    positionTooltip(button);
  }

  function onPointerOut(event) {
    const button = event.target.closest?.('.cart-item__disclosure');
    if (button && !button.contains(event.relatedTarget)) {
      delete button.dataset.tooltipPositioned;
    }
  }

  document.addEventListener('pointerover', onPointerOver);
  document.addEventListener('pointerout', onPointerOut);
})();

/* Splity purchase/subscription fixes — 2026-10-02 */
(() => {
  if (window.__splityPurchaseSubscriptionFixesV1) return;
  window.__splityPurchaseSubscriptionFixesV1 = true;

  /*
   * Always enter the buy catalogue with a clean selection. The explorer
   * understands splityReset=1 and will not reuse the last HBO/other group.
   * This listener lives on window capture so it runs before legacy drawer
   * click handlers that still use ?mode=buy/share.
   */
  window.addEventListener('click', (event) => {
    const link = event.target.closest?.('.splity-shared-menu a[href]');
    if (!link) return;

    const href = String(link.getAttribute('href') || '');
    const isBuy = link.hasAttribute('data-shared-buy') || /[?&]mode=buy(?:&|$)/.test(href);
    const isShare = /[?&]mode=share(?:&|$)/.test(href);
    if (!isBuy && !isShare) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (isBuy) {
      try {
        sessionStorage.removeItem('splity-buy-intent');
        localStorage.removeItem('splity-buy-intent');
      } catch (_) {}
    }

    const url = new URL('/pages/explorar-servicios', window.location.origin);
    url.searchParams.set('splityCatalog', '1');
    url.searchParams.set('splityMode', isBuy ? 'buy' : 'share');
    if (isBuy) url.searchParams.set('splityReset', '1');
    url.searchParams.set('splityFresh', Date.now().toString());
    document.documentElement.style.overflow = '';
    window.location.assign(url.toString());
  }, true);

  const style = document.createElement('style');
  style.id = 'splity-purchased-subscription-fixes-v1';
  style.textContent = `
    /* Mis Suscripciones: tarjetas de lista más compactas, sin tocar Mis Grupos. */
    [data-groups-list] .splity-buyer-card{
      width:min(100%,680px)!important;
      max-width:680px!important;
      margin:0 auto!important;
      padding:12px 13px!important;
      border-radius:15px!important;
    }
    [data-groups-list] .splity-buyer-card .splity-owner-card__top{
      min-height:38px!important;
      padding-bottom:7px!important;
    }
    [data-groups-list] .splity-buyer-card .splity-owner-card__top h2{
      font-size:18px!important;
    }
    [data-groups-list] .splity-buyer-card .splity-owner-card__top h2>span{
      width:38px!important;height:38px!important;min-width:38px!important;
      font-size:19px!important;border-radius:11px!important;
    }
    [data-groups-list] .splity-buyer-card .splity-owner-card__top>strong{
      min-height:30px!important;padding:7px 10px!important;font-size:12px!important;border-radius:10px!important;
    }
    [data-groups-list] .splity-buyer-card .splity-owner-card__stats{
      grid-template-columns:repeat(2,minmax(0,1fr))!important;
      gap:6px!important;margin-top:7px!important;
    }
    [data-groups-list] .splity-buyer-card .splity-owner-card__stats>div{
      min-height:58px!important;padding:7px 6px!important;border-radius:10px!important;
    }
    [data-groups-list] .splity-buyer-card .splity-owner-card__stats small{font-size:11px!important}
    [data-groups-list] .splity-buyer-card .splity-owner-card__stats b{font-size:17px!important}
    [data-groups-list] .splity-buyer-card .splity-card-community{
      min-height:34px!important;margin:3px 0!important;padding:2px 0!important;
    }
    [data-groups-list] .splity-buyer-card .splity-owner-avatars{min-height:32px!important}
    [data-groups-list] .splity-buyer-card .splity-owner-avatars>span{width:30px!important;height:30px!important;margin-left:-6px!important}
    [data-groups-list] .splity-buyer-card .splity-owner-avatars>span.is-owner{width:34px!important;height:34px!important}
    [data-groups-list] .splity-buyer-card .splity-buyer-meta{
      margin-top:3px!important;padding:7px 9px!important;border-radius:10px!important;font-size:11px!important;line-height:1.3!important;
    }
    [data-groups-list] .splity-buyer-card .splity-buyer-meta small{font-size:10px!important}
    [data-groups-list] .splity-buyer-card>button[data-open-purchase]{
      width:min(72%,320px)!important;min-width:190px!important;min-height:40px!important;
      margin:7px auto 1px!important;padding:8px 14px!important;border-radius:10px!important;font-size:15px!important;
    }

    /* Periodo: contraste correcto en modo oscuro dentro de la lista. */
    html[data-splity-theme="dark"] [data-groups-list] .splity-buyer-card .splity-owner-card__stats>div:nth-child(2) b,
    html:not([data-splity-theme="light"]) [data-groups-list] .splity-buyer-card .splity-owner-card__stats>div:nth-child(2) b{
      color:#f7f3fb!important;
      text-shadow:none!important;
    }

    /* Detalle del cupo comprado: tres tarjetas en una sola fila y más compactas. */
    [data-group-detail].splity-purchased-detail .splity-owner-stat-row{
      display:grid!important;
      grid-template-columns:repeat(3,minmax(0,1fr))!important;
      gap:8px!important;
      width:min(760px,100%)!important;
      margin:8px auto 10px!important;
    }
    [data-group-detail].splity-purchased-detail .splity-owner-stat-row>article{
      min-width:0!important;min-height:82px!important;
      padding:11px 9px!important;border-radius:13px!important;
    }
    [data-group-detail].splity-purchased-detail .splity-owner-stat-row>article small{
      font-size:11px!important;line-height:1.2!important;
    }
    [data-group-detail].splity-purchased-detail .splity-owner-stat-row>article strong{
      font-size:19px!important;line-height:1.12!important;overflow-wrap:anywhere!important;
    }
    [data-group-detail].splity-purchased-detail .splity-owner-stat-row>article>span{
      margin-top:3px!important;font-size:10px!important;line-height:1.25!important;
    }
    html[data-splity-theme="dark"] [data-group-detail].splity-purchased-detail .splity-owner-stat-row>article>span,
    html:not([data-splity-theme="light"]) [data-group-detail].splity-purchased-detail .splity-owner-stat-row>article>span{
      color:#d8d1df!important;opacity:1!important;
    }
    html[data-splity-theme="dark"] [data-group-detail].splity-purchased-detail .splity-owner-stat-row>article:first-child>span,
    html:not([data-splity-theme="light"]) [data-group-detail].splity-purchased-detail .splity-owner-stat-row>article:first-child>span{
      color:#f1edf5!important;
    }

    /* Acceso privado del comprador. */
    [data-group-detail] .splity-buyer-access{
      width:min(760px,100%)!important;margin:10px auto!important;padding:15px!important;
      border:1px solid rgba(124,58,237,.38)!important;border-radius:16px!important;
      background:linear-gradient(145deg,#111017,#0b0a0f)!important;color:#fff!important;
      box-shadow:0 12px 30px rgba(0,0,0,.16)!important;
    }
    [data-group-detail] .splity-buyer-access__head{
      display:flex!important;align-items:center!important;justify-content:space-between!important;gap:12px!important;margin-bottom:11px!important;
    }
    [data-group-detail] .splity-buyer-access__head small{
      display:block!important;color:#a78bfa!important;font-size:9px!important;font-weight:900!important;letter-spacing:.11em!important;
    }
    [data-group-detail] .splity-buyer-access__head h2{
      margin:2px 0 0!important;color:#fff!important;font-size:17px!important;line-height:1.2!important;
    }
    [data-group-detail] .splity-buyer-access__private{
      flex:none!important;padding:5px 8px!important;border:1px solid rgba(52,211,153,.28)!important;border-radius:999px!important;
      background:rgba(52,211,153,.08)!important;color:#62e7b5!important;font-size:9px!important;font-weight:850!important;
    }
    [data-group-detail] .splity-buyer-access__body{display:grid!important;gap:8px!important}
    [data-group-detail] .splity-buyer-access__row{
      display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;align-items:center!important;gap:10px!important;
      min-height:52px!important;padding:9px 10px!important;border:1px solid #322b3b!important;border-radius:12px!important;background:#17151d!important;
    }
    [data-group-detail] .splity-buyer-access__copy{min-width:0!important}
    [data-group-detail] .splity-buyer-access__copy small{
      display:block!important;margin-bottom:3px!important;color:#aaa2b3!important;font-size:9px!important;font-weight:750!important;
    }
    [data-group-detail] .splity-buyer-access__value{
      display:block!important;max-width:100%!important;overflow-wrap:anywhere!important;color:#fff!important;font-size:13px!important;font-weight:800!important;line-height:1.3!important;
    }
    [data-group-detail] .splity-buyer-access__actions{display:flex!important;align-items:center!important;gap:5px!important}
    [data-group-detail] .splity-buyer-access__button,
    [data-group-detail] .splity-buyer-access__link{
      min-height:34px!important;padding:7px 9px!important;border:1px solid #4d3b66!important;border-radius:9px!important;
      background:#09080d!important;color:#fff!important;font:inherit!important;font-size:10px!important;font-weight:850!important;text-decoration:none!important;cursor:pointer!important;
    }
    [data-group-detail] .splity-buyer-access__button:hover,
    [data-group-detail] .splity-buyer-access__link:hover{background:#713df2!important;border-color:#936fff!important}
    [data-group-detail] .splity-buyer-access__empty{
      margin:0!important;padding:11px 12px!important;border:1px dashed #493b5c!important;border-radius:12px!important;
      color:#c9c2d1!important;font-size:11px!important;line-height:1.45!important;
    }
    html[data-splity-theme="light"] [data-group-detail] .splity-buyer-access{
      background:#fff!important;color:#151018!important;border-color:#d9ccff!important;box-shadow:0 10px 28px rgba(70,45,110,.08)!important;
    }
    html[data-splity-theme="light"] [data-group-detail] .splity-buyer-access__head h2,
    html[data-splity-theme="light"] [data-group-detail] .splity-buyer-access__value{color:#151018!important}
    html[data-splity-theme="light"] [data-group-detail] .splity-buyer-access__row{background:#faf9fd!important;border-color:#e1dcea!important}
    html[data-splity-theme="light"] [data-group-detail] .splity-buyer-access__copy small{color:#626875!important}
    html[data-splity-theme="light"] [data-group-detail] .splity-buyer-access__empty{color:#5f5868!important;border-color:#d8d0e3!important}

    @media(max-width:560px){
      [data-group-detail].splity-purchased-detail .splity-owner-stat-row{gap:5px!important}
      [data-group-detail].splity-purchased-detail .splity-owner-stat-row>article{min-height:74px!important;padding:9px 5px!important}
      [data-group-detail].splity-purchased-detail .splity-owner-stat-row>article small{font-size:9px!important}
      [data-group-detail].splity-purchased-detail .splity-owner-stat-row>article strong{font-size:15px!important}
      [data-group-detail].splity-purchased-detail .splity-owner-stat-row>article>span{font-size:8px!important}
      [data-group-detail] .splity-buyer-access{padding:12px!important}
      [data-group-detail] .splity-buyer-access__row{grid-template-columns:1fr!important;gap:7px!important}
      [data-group-detail] .splity-buyer-access__actions{justify-content:flex-start!important}
      [data-groups-list] .splity-buyer-card{padding:10px!important}
    }
  `;
  document.head.appendChild(style);

  if (!/^\/pages\/mis-grupos(?:\/|$)/.test(window.location.pathname)) return;

  const readSession = () => {
    try {
      return JSON.parse(localStorage.getItem('splity-auth-session') || sessionStorage.getItem('splity-auth-session') || 'null');
    } catch (_) {
      return null;
    }
  };

  const readConfig = () => {
    const node = document.querySelector('[data-splity-my-groups-config]');
    if (!node) return null;
    try { return JSON.parse(node.textContent || '{}'); } catch (_) { return null; }
  };

  let membershipsPromise = null;
  const loadMemberships = () => {
    if (membershipsPromise) return membershipsPromise;
    membershipsPromise = (async () => {
      const config = readConfig();
      const session = readSession();
      const token = String(session?.accessToken || '').trim();
      const email = String(config?.customer?.email || session?.user?.email || '').trim().toLowerCase();
      if (!config || !email) return [];

      const proxyBase = String(config.settings?.apiProxyBaseUrl || '').replace(/\/+$/, '');
      const directBase = String(config.settings?.apiBaseUrl || 'https://splity-backend-48dv.onrender.com').replace(/\/+$/, '');
      const base = proxyBase || directBase;
      const cleanPath = proxyBase ? '/my-memberships' : '/api/my-memberships';
      const url = new URL(base + cleanPath, window.location.origin);
      url.searchParams.set('email', email);
      url.searchParams.set('t', Date.now().toString());

      const response = await fetch(url.toString(), {
        credentials: proxyBase ? 'same-origin' : 'omit',
        headers: {
          Accept: 'application/json',
          ...(token ? { Authorization: 'Bearer ' + token } : {})
        }
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || data.ok === false) throw new Error(data.error || 'No se pudo cargar el acceso');
      return Array.isArray(data.memberships) ? data.memberships : [];
    })().catch((error) => {
      membershipsPromise = null;
      throw error;
    });
    return membershipsPromise;
  };

  const objectOrEmpty = (value) => value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  const firstText = (...values) => {
    for (const value of values) {
      if (value === undefined || value === null) continue;
      const text = String(value).trim();
      if (text) return text;
    }
    return '';
  };

  const extractAccess = (membership) => {
    const access = objectOrEmpty(membership?.access);
    const credentials = objectOrEmpty(membership?.credentials);
    const accessData = objectOrEmpty(membership?.accessData);
    const groupAccess = objectOrEmpty(membership?.groupAccess);

    return {
      type: firstText(
        membership?.accessType,
        membership?.accessModel,
        access.type,
        access.model,
        accessData.type,
        groupAccess.type
      ).toLowerCase(),
      login: firstText(
        membership?.accessEmail,
        membership?.accessUsername,
        membership?.loginEmail,
        membership?.loginUsername,
        membership?.credentialEmail,
        membership?.credentialUsername,
        membership?.access_email,
        access.email,
        access.username,
        access.login,
        credentials.email,
        credentials.username,
        credentials.login,
        accessData.email,
        accessData.username,
        groupAccess.email,
        groupAccess.username
      ),
      password: firstText(
        membership?.accessPassword,
        membership?.loginPassword,
        membership?.credentialPassword,
        membership?.access_password,
        access.password,
        credentials.password,
        accessData.password,
        groupAccess.password
      ),
      invite: firstText(
        membership?.inviteLink,
        membership?.invitationLink,
        membership?.invitationUrl,
        membership?.inviteUrl,
        membership?.accessUrl,
        membership?.invite_link,
        access.inviteLink,
        access.invitationLink,
        access.inviteUrl,
        access.url,
        credentials.inviteLink,
        accessData.inviteLink,
        accessData.url,
        groupAccess.inviteLink,
        groupAccess.url
      )
    };
  };

  const safeInvitationUrl = (value) => {
    try {
      const url = new URL(String(value || '').trim(), window.location.origin);
      return url.protocol === 'https:' ? url.href : '';
    } catch (_) {
      return '';
    }
  };

  const copyText = async (value, button) => {
    if (!value) return;
    const original = button.textContent;
    try {
      await navigator.clipboard.writeText(value);
    } catch (_) {
      const area = document.createElement('textarea');
      area.value = value;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      document.execCommand('copy');
      area.remove();
    }
    button.textContent = 'Copiado ✓';
    window.setTimeout(() => { button.textContent = original; }, 1300);
  };

  const makeAccessRow = (label, value, options = {}) => {
    const row = document.createElement('div');
    row.className = 'splity-buyer-access__row';

    const copy = document.createElement('div');
    copy.className = 'splity-buyer-access__copy';
    const caption = document.createElement('small');
    caption.textContent = label;
    const shown = document.createElement('span');
    shown.className = 'splity-buyer-access__value';
    shown.textContent = options.masked ? '••••••••' : value;
    copy.append(caption, shown);

    const actions = document.createElement('div');
    actions.className = 'splity-buyer-access__actions';

    if (options.masked) {
      const reveal = document.createElement('button');
      reveal.type = 'button';
      reveal.className = 'splity-buyer-access__button';
      reveal.textContent = 'Mostrar';
      let visible = false;
      reveal.addEventListener('click', () => {
        visible = !visible;
        shown.textContent = visible ? value : '••••••••';
        reveal.textContent = visible ? 'Ocultar' : 'Mostrar';
      });
      actions.appendChild(reveal);
    }

    if (options.url) {
      const safeUrl = safeInvitationUrl(value);
      if (safeUrl) {
        const open = document.createElement('a');
        open.className = 'splity-buyer-access__link';
        open.href = safeUrl;
        open.target = '_blank';
        open.rel = 'noopener noreferrer';
        open.textContent = 'Abrir';
        actions.appendChild(open);
      }
    }

    const copyButton = document.createElement('button');
    copyButton.type = 'button';
    copyButton.className = 'splity-buyer-access__button';
    copyButton.textContent = 'Copiar';
    copyButton.addEventListener('click', () => copyText(value, copyButton));
    actions.appendChild(copyButton);

    row.append(copy, actions);
    return row;
  };

  const mountPurchasedDetail = async () => {
    const detail = document.querySelector('[data-group-detail]');
    if (!detail || detail.hidden) return;

    const groupTrigger = detail.querySelector('[data-splity-open-message][data-group-id], [data-splity-whatsapp-contact][data-group-id]');
    const groupId = String(groupTrigger?.dataset.groupId || '').trim();
    if (!groupId) {
      detail.classList.remove('splity-purchased-detail');
      return;
    }

    detail.classList.add('splity-purchased-detail');
    if (detail.dataset.splityAccessFor === groupId && detail.querySelector('[data-splity-buyer-access]')) return;
    if (detail.dataset.splityAccessLoading === groupId) return;
    detail.dataset.splityAccessLoading = groupId;

    detail.querySelector('[data-splity-buyer-access]')?.remove();
    const panel = document.createElement('section');
    panel.className = 'splity-owner-panel splity-buyer-access';
    panel.dataset.splityBuyerAccess = '';

    const head = document.createElement('div');
    head.className = 'splity-buyer-access__head';
    const titleWrap = document.createElement('div');
    const kicker = document.createElement('small');
    kicker.textContent = 'TU ACCESO';
    const title = document.createElement('h2');
    title.textContent = 'Datos de acceso';
    titleWrap.append(kicker, title);
    const privacy = document.createElement('span');
    privacy.className = 'splity-buyer-access__private';
    privacy.textContent = 'Privado';
    head.append(titleWrap, privacy);

    const body = document.createElement('div');
    body.className = 'splity-buyer-access__body';
    const loading = document.createElement('p');
    loading.className = 'splity-buyer-access__empty';
    loading.textContent = 'Cargando los datos de acceso de tu suscripción…';
    body.appendChild(loading);
    panel.append(head, body);

    const accessStatusPanel = detail.querySelector('.splity-owner-status');
    if (accessStatusPanel) accessStatusPanel.before(panel);
    else detail.querySelector('.splity-owner-stat-row')?.after(panel);

    try {
      const memberships = await loadMemberships();
      const membership = memberships.find((item) => String(item?.groupId || item?.id || '') === groupId);
      body.replaceChildren();

      if (!membership) {
        const empty = document.createElement('p');
        empty.className = 'splity-buyer-access__empty';
        empty.textContent = 'No pudimos encontrar los datos de acceso de este cupo. Actualiza la página o contacta a soporte.';
        body.appendChild(empty);
      } else {
        const access = extractAccess(membership);
        if (access.login) body.appendChild(makeAccessRow('Correo o usuario', access.login));
        if (access.password) body.appendChild(makeAccessRow('Contraseña', access.password, { masked: true }));
        if (access.invite) body.appendChild(makeAccessRow('Enlace de invitación', access.invite, { url: true }));

        if (!access.login && !access.password && !access.invite) {
          const empty = document.createElement('p');
          empty.className = 'splity-buyer-access__empty';
          empty.textContent = access.type.includes('inv') || access.type.includes('link')
            ? 'El enlace de invitación aún no ha sido liberado. Cuando esté disponible aparecerá aquí.'
            : 'Los datos de acceso aún no han sido liberados. Cuando estén disponibles aparecerán aquí.';
          body.appendChild(empty);
        }
      }

      detail.dataset.splityAccessFor = groupId;
    } catch (_) {
      body.replaceChildren();
      const empty = document.createElement('p');
      empty.className = 'splity-buyer-access__empty';
      empty.textContent = 'No pudimos cargar tus datos de acceso en este momento. Intenta nuevamente en unos segundos.';
      body.appendChild(empty);
    } finally {
      if (detail.dataset.splityAccessLoading === groupId) delete detail.dataset.splityAccessLoading;
    }
  };

  let frame = 0;
  const scheduleMount = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(mountPurchasedDetail);
  };

  const root = document.querySelector('[data-splity-my-groups]') || document.body;
  new MutationObserver(scheduleMount).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden'] });
  scheduleMount();
})();
